import { useTheme } from '@/hooks/useTheme';
import { Button } from '@/components/ui/button';
import { Sun, Moon } from 'lucide-react';

export function ThemeToggle({ isCollapsed = false }: { isCollapsed?: boolean }) {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <Button
      variant="ghost"
      onClick={toggleTheme}
      aria-label="Toggle theme"
      className={`w-full h-9 justify-start ${isCollapsed ? 'justify-center px-2' : ''}`}
    >
      {isDark ? (
        <Moon className={`h-5 w-5 shrink-0 ${!isCollapsed ? 'mr-3' : ''}`} />
      ) : (
        <Sun className={`h-5 w-5 shrink-0 ${!isCollapsed ? 'mr-3' : ''}`} />
      )}
      {!isCollapsed && <span>{isDark ? 'Lights On' : 'Lights Off'}</span>}
    </Button>
  );
}
